/* 对window中localStorage的封装 */
let myStorage = {
  install: (Vue, options) => {
    Vue.prototype.$localstorage = myStorage
  },
  save(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  get(key, defaultValue = {}) {
    //console.log('storage组件中的值=====', localStorage.getItem(key))
    //return JSON.parse(localStorage.getItem(key)) || defaultValue
    return JSON.parse(localStorage.getItem(key))
  },
  get2(key, defaultValue = {}) {
    return localStorage.getItem(key)
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  clear() {
    localStorage.clear()
  }
}
export default myStorage
